export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ffbd39b57f48a4ea67dc981bbbdffa147d47ebb6e&name=fetchTypeahead!'